// "Connecting to SAM…" + Cancel, shown while an Interactive session is being set up (realtime connection and
// microphone). It replaces the Listening / Mic / Speaker pills until the session is really ready to hear the user.
import { Button } from '@/components/UI/Button';
import { cn } from '@/utils/cn';

export const VoiceConnecting = ({ onCancel, className }: { onCancel: () => void; className?: string }) => (
  <div className={cn('relative flex items-center justify-between gap-3 px-4 pb-2 pt-3', className)}>
    <div className="voice-connecting-bar" aria-hidden="true" />
    <span role="status" aria-live="polite" className="voice-fade inline-flex items-center gap-2.5 text-sm text-ui-text2">
      <span className="voice-orb" aria-hidden="true"><i /><i /><i /><b /></span>
      <span>
        Connecting to SAM
        <span className="voice-dots" aria-hidden="true"><span>.</span><span>.</span><span>.</span></span>
      </span>
    </span>
    <Button
      size="sm"
      variant="ghost"
      onClick={onCancel}
      className="voice-fade bg-accent-soft text-accent-text hover:bg-accent-soft hover:brightness-110 hover:text-accent-text"
    >
      Cancel
    </Button>
  </div>
);
